<div class="fundo-barragem">
  <div class="conteudo text-center">
    <div class="conteudo caixa-branca">
    <h2 class="text-3xl font-bold text-black mb-4">VISÃO GERAL – SEIRA</h2>


    <div class="justificado space-y-4">
      <p *ngFor="let paragrafo of textoPrincipal">{{ paragrafo }}</p>
  
      <p><strong>Entre os principais produtos do sistema, destacam-se:</strong></p>
      <ul class="list-disc ml-6 space-y-1">
        <li *ngFor="let item of listaProdutos">{{ item }}</li>
      </ul>
  
      <p *ngFor="let paragrafo of textoFinal">{{ paragrafo }}</p>
    </div>
  </div>
  